module.exports = __webpack_public_path__ + "img/10979906_L.4fd90182.png";